export interface CrewMemberRecipientRow {
  crew_id: string;
  contact: {
    id: string;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
  } | null;
}

export interface CrewEmailRecipient {
  entityId: string;
  entityType: 'crew';
  email: string;
  name: string;
  selected: boolean;
}

export function buildCrewMemberRecipients(rows: CrewMemberRecipientRow[]): CrewEmailRecipient[] {
  const recipients: CrewEmailRecipient[] = [];

  rows.forEach((member) => {
    const contact = member.contact;
    if (!contact?.email) return;

    // La même adresse peut représenter plusieurs équipages sélectionnés : le
    // contexte crew doit rester distinct pour résoudre {{lien.bed}}. On ne
    // déduplique que les doublons d'une même adresse au sein du même crew.
    const exists = recipients.some(
      (recipient) => recipient.entityId === member.crew_id && recipient.email === contact.email
    );
    if (exists) return;

    recipients.push({
      entityId: member.crew_id,
      entityType: 'crew',
      email: contact.email,
      name: `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.email,
      selected: true,
    });
  });

  return recipients;
}
